import { z } from "zod"

import {
  financeConfigurationApplyV1Schema,
  financeConfigurationResultV1Schema,
} from "./finance-configuration-v1.js"

export const financeConfigurationApplyV2Schema = z.object({
  ...financeConfigurationApplyV1Schema.shape,
  requestVersion: z.literal(2),
  completionGraceMinutes: z.number().int().min(0).max(1_440),
}).strict()

export const financeConfigurationResultV2Schema = z.object({
  ...financeConfigurationResultV1Schema.shape,
  completionGraceMinutes: z.number().int().min(0).max(1_440),
}).strict()

export type FinanceConfigurationApplyV2 = z.infer<
  typeof financeConfigurationApplyV2Schema
>
export type FinanceConfigurationResultV2 = z.infer<
  typeof financeConfigurationResultV2Schema
>
